import { CategoryPromotedProductsSkeleton } from 'components/Blocks/Product/CategoryPromotedProducts/CategoryPromotedProductsSkeleton';
import { ProductsList } from 'components/Blocks/Product/CategoryPromotedProducts/ProductsList/ProductsList';
import ProductsSlider from 'components/Blocks/Product/ProductsSlider';
import { usePersoo } from 'hooks/persoo/usePersoo';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import { PERSOO_IDS } from 'modules/persoo/persooTypes';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { SliderProductItemType } from 'types/product';

const GTM_LIST_NAME = 'top products' as const;

type CategoryPromotedProductsProps = {
    items: SliderProductItemType[];
};

export const CategoryPromotedProducts: FC<CategoryPromotedProductsProps> = ({ items }) => {
    const { t } = useTranslation();
    const { isPersooAllowed } = usePersoo();

    const isDesktop = useMediaMin('vl');

    const PromotedProducts = useMemo(() => {
        if (typeof isDesktop === 'undefined') {
            return <CategoryPromotedProductsSkeleton />;
        }

        if (isDesktop) {
            return <ProductsList gtmListName={GTM_LIST_NAME} products={items} />;
        }

        return (
            <ProductsSlider noMarginBottom gtmListName={GTM_LIST_NAME} idSuffix="-promoted-slider" products={items} />
        );
    }, [isDesktop, items]);

    if (items.length === 0) {
        return null;
    }

    return (
        <div
            className="mb-8 border-y-[5px] border-grayLight pb-4 pt-5 vl:rounded-md vl:border-[5px] vl:px-6"
            id={isPersooAllowed ? PERSOO_IDS.topProducts : undefined}
        >
            <h2 className="!text-h6 font-medium leading-6 md:mr-28 vl:mr-0 vl:text-center">
                {t('Do not want to choose? Choose certainty')}
            </h2>
            {PromotedProducts}
        </div>
    );
};
